export const CREATE_FEEDBACK_REQUEST = 'CREATE_FEEDBACK_REQUEST'
export const CREATE_FEEDBACK_SUCCESS = 'CREATE_FEEDBACK_SUCCESS'
export const CREATE_FEEDBACK_FAIL = 'CREATE_FEEDBACK_FAIL'
export const CREATE_FEEDBACK_RESET = 'CREATE_FEEDBACK_RESET'

export const GET_FEEDBACK_REQUEST = 'GET_FEEDBACK_REQUEST'
export const GET_FEEDBACK_SUCCESS = 'GET_FEEDBACK_SUCCESS'
export const GET_FEEDBACK_FAIL = 'GET_FEEDBACK_FAIL'
export const GET_FEEDBACK_RESET = 'GET_FEEDBACK_RESET'

export const GET_FEEDBACK_CONTENT_REQUEST = 'GET_FEEDBACK_CONTENT_REQUEST'
export const GET_FEEDBACK_CONTENT_SUCCESS = 'GET_FEEDBACK_CONTENT_SUCCESS'
export const GET_FEEDBACK_CONTENT_FAIL = 'GET_FEEDBACK_CONTENT_FAIL'
export const GET_FEEDBACK_CONTENT_RESET = 'GET_FEEDBACK_CONTENT_RESET'

export const GET_CALL_TYPES_REQUEST = 'GET_CALL_TYPES_REQUEST'
export const GET_CALL_TYPES_SUCCESS = 'GET_CALL_TYPES_SUCCESS'
export const GET_CALL_TYPES_FAIL = 'GET_CALL_TYPES_FAIL' 